import React from "react";
import Title from "../../../components/Title/Title";

const StudentVolunteers2027page = () => {
    return (
        <div>
            <Title>Student Volunteers</Title>
            <p> [COMING SOON] </p>
        </div>
    )
}

export default StudentVolunteers2027page
